import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Chip, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  getAllBrands,
  getCategoryTypes,
} from "../../../redux/features/assetManagementSlice";
import AddType from "./AddType";
import DeleteType from "./DeleteType";
import EditType from "./EditType";
import apiRequest from "../../../api/request";
import { Icon } from "@iconify/react/dist/iconify.js";

const Type = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { categoryTypes, loading } = useSelector(
    (state) => state.assetmanagement
  );
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getCategoryTypes(data));
    }
  }, [pageNum, gridSize]);

  // Export should include every record, not only the visible page (limit=no returns all rows)
  const fetchAllTypesForExport = async () => {
    const res = await apiRequest({
      method: "get",
      url: `category-types/?page=1&limit=no`,
    });
    return res?.data || [];
  };

  const Asset_Table_Head = [
    { field: "sl_no", headerName: "Sl No", width: 100 },
    { field: "category_type_name", headerName: "Type Name", width: 150 },
    {
      field: "is_returnable",
      headerName: "Returnable ?",
      width: 150,
      renderCell: (params) => {
        if (params.row.is_returnable === false) {
          return <Chip color="error" label="NO" variant="outlined" />;
        } else {
          return <Chip color="primary" label="YES" variant="outlined" />;
        }
      },
    },
    { field: "createdAt", headerName: "Created At", width: 200 },
  ];

  return (
    <GlobalWrapper title={"Types"} actions={<AddType dispatchParams={data} />}>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Asset_Table_Head}
          rows={categoryTypes}
          meta={categoryTypes?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="category_type_id"
          exportAllRows={fetchAllTypesForExport}
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.category_type_name} />
              <GlobalAnchorList
                label=""
                component={<EditType rowData={rowData} dispatchParams={data} />}
              />
              <GlobalAnchorList
                label=""
                component={
                  <DeleteType
                    rowData={rowData}
                    data={data}
                    id={rowData?.category_type_id}
                  />
                }
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default Type;
